import React, { useEffect, useState } from "react";
import JdentIcon from "./JdentIcon";
import { GetAllLeaderBoardList } from "../service/leaderBoard";
import gold from "../images/gold.svg";
import silver from "../images/silver.svg";
import bronze from "../images/bronze.svg";
import { useParams } from "react-router-dom";
import CoinSkeleton from "../Skeleton/CoinSkeleton";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";

function LeaderBoard() {
  let { cryptoId, username } = useParams();
  const [leaderList, setLeaderList] = useState([]);
  const [coinDetail, setCoinDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 800);
  const [activeStep, setActiveStep] = useState("all-time");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const loadFunc = (page) => {
    let refer = username;
    if (cryptoId && cryptoId.includes(".buy")) {
      refer = cryptoId.replace(".buy", "");
    }
    getLeaderBoardData(cryptoId, refer, activeStep, page + 1);
  };

  const getLeaderBoardData = (cryptoId, username, activeStep, page) => {
    setPage(page);
    const pageLimit = `&page=${page}&limit=10`;
    setIsLoading(true);

    let refer = username;
    if (refer || cryptoId) {
      if (cryptoId && cryptoId.includes(".buy")) {
        refer = cryptoId.replace(".buy", "");
      } else {
        refer = refer.replace(".buy", "");
      }
    }
    GetAllLeaderBoardList({ username: refer, cryptoId, activeStep, pageLimit })
      .then((res) => {
        setIsLoading(false);
        const data = res.data.data.data;
        const coinData = res.data.data.coinDetail;
        setLeaderList((prevData) =>
          _.orderBy([...prevData, ...data], "total_rip_point", "desc")
        );
        setCoinDetail(coinData);
        if (!data || data.length <= 0 || data.length < 10) {
          setHasMore(false);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    setHasMore(true);
    setPage(1);
    setLeaderList([]);
    getLeaderBoardData(cryptoId, username, activeStep, 1);
  }, [activeStep, username, cryptoId]);

  function extractFromAddress(address) {
    if (address) {
      const firstSix = address.substring(0, 6);
      const lastFour = address.substring(address.length - 4);

      return `${firstSix}...${lastFour}`;
    }
  }

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth < 800);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="relative mx-6">
      <div className="max-w-6xl mx-auto">
        <div className="pt-24 pb-12 md:pt-28 md:pb-20">
          <div className="pb-12 md:pb-16">
            <div className="relative max-w-4xl mx-auto px-4 sm:px-6 grid gap-4 md:grid-cols-1">
              <div
                className="text-white lg:mx-20 md:mx-10 font-bold"
                style={{ fontSize: "32px" }}
              >
                Leaderboard
              </div>
              <label
                className="lg:mx-20 md:mx-10 text-gray-600 mb-4"
                style={{ fontSize: "12px" }}
              >
                <span
                  role="button"
                  className={`${
                    activeStep === "all-time" ? "text-white" : "text-gray-600"
                  }`}
                  onClick={() => setActiveStep("all-time")}
                >
                  All-Time
                </span>{" "}
                /{" "}
                <span
                  role="button"
                  className={`${
                    activeStep === "30-days" ? "text-white" : "text-gray-600"
                  }`}
                  onClick={() => setActiveStep("30-days")}
                >
                  Last 30 days
                </span>{" "}
                /{" "}
                <span
                  role="button"
                  className={`${
                    activeStep === "7-days" ? "text-white" : "text-gray-600"
                  }`}
                  onClick={() => setActiveStep("7-days")}
                >
                  Last 7 days
                </span>
                /{" "}
                <span
                  role="button"
                  className={`${
                    activeStep === "24-hr" ? "text-white" : "text-gray-600"
                  }`}
                  onClick={() => setActiveStep("24-hr")}
                >
                  Last 24 hrs
                </span>
              </label>
              {cryptoId && coinDetail && coinDetail.coin_name && (
                <div className={`${username ? "" : "mb-4"} lg:mx-20 md:mx-10`}>
                  <div className="flex items-center">
                    <div
                      className="flex justify-center items-center"
                      style={{ flexDirection: "column" }}
                    >
                      <img
                        src={coinDetail.logo}
                        alt=""
                        width={60}
                        style={{ maxHeight: "60px", borderRadius: "50%" }}
                      />{" "}
                      <span className="text-white text-md mt-3">
                        {_.startCase(coinDetail.coin_name)}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {username && !isLoading && (
                <div className="mb-4 lg:mx-20 md:mx-10">
                  <div className="flex items-center">
                    <div
                      className="flex justify-center items-center"
                      style={{ flexDirection: "column" }}
                    >
                      <span className="text-white text-md">@{username}</span>
                    </div>
                  </div>
                </div>
              )}

              <InfiniteScroll
                style={{ overflow: "hidden" }}
                dataLength={leaderList.length}
                next={() => {
                  loadFunc(page);
                }}
                hasMore={hasMore}
                loader={
                  <CoinSkeleton
                    cryptoId={cryptoId}
                    isSmallScreen={isSmallScreen}
                    leaderList={leaderList}
                  />
                }
              >
                {leaderList && leaderList.length > 0 ? (
                  <>
                    {leaderList.map((leader, index) => (
                      <div
                        key={leader._id}
                        className="card transaction-card lg:mx-20 md:mx-10 money-input application-card-border flex items-center justify-between"
                      >
                        <div className="flex items-center justify-center">
                          <div
                            className="text-white mr-3"
                            style={{ width: 32 }}
                          >
                            {index === 0 ? (
                              <img src={gold} alt="gold" />
                            ) : index === 1 ? (
                              <img src={silver} alt="silver" />
                            ) : index === 2 ? (
                              <img src={bronze} alt="bronze" />
                            ) : (
                              <span className="ml-3">{index + 1}</span>
                            )}
                          </div>
                          <JdentIcon value={leader._id} size="48" />
                          <span className="ml-2 text-sm text-white">
                            {isSmallScreen
                              ? extractFromAddress(leader._id.toUpperCase())
                              : leader._id.toUpperCase()}
                          </span>
                        </div>
                        <div
                          style={{ justifyContent: "flex-start" }}
                          className="flex"
                        >
                          <span className="text-md text-green-500 font-bold ">
                            +{leader.total_rip_point} BUY pts
                          </span>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {!isLoading && (
                      <div className="card transaction-card lg:mx-20 md:mx-10 money-input application-card-border flex items-center justify-between text-white">
                        Swap now to get on the leaderboard
                      </div>
                    )}
                  </>
                )}
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LeaderBoard;
